// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detail-wrap[data-v-37d9716c] {\n  min-height: calc(100vh - 150px);\n}\n", ""]);
// Exports
module.exports = exports;
